import { render, staticRenderFns } from "./SiteOrdersTable.vue?vue&type=template&id=483fd232&"
import script from "./SiteOrdersTable.vue?vue&type=script&lang=js&"
export * from "./SiteOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./SiteOrdersTable.vue?vue&type=style&index=0&id=483fd232&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports